import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, JOBS } from "../../../common/URLs";


export const JobPublishOrUnpublish = async (uuid, keyword) => {
  try {
    const token = await fetchToken()
    
    const response = await fetch(`${BASE_URL}/${EMPLOYER}/${JOBS}/${keyword}/${uuid}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log("response in api", response)

    if (!response.ok) {
      throw new Error("Failed");
    }

    const data = await response.json();
    return data; // Return the uploaded logo data (e.g., URL, ID, etc.)
  } catch (error) {
    // console.log("error in api", error)
    throw new Error(error);
  }
};